export const table_fields = [
    {
        text: '申请团队',
        value: 'apply_team_id',
        align: 'center',
        sortable: false, 
        width: 150
    },
    {
        text: '审批名称',
        value: 'name',
        align: 'center',
        sortable: false,
        width: 180
    },
    {
        text: '总金额',
        value: 'total_amount',
        align: 'right',
        sortable: false,  
        width: 120
    },
    {
        text: '预算时间',
        value: 'quarter_start_at',
        align: 'center',
        sortable: false,
        width: 180
    },
    {
        text: '申请事由',
        value: 'apply_reason',
        align: 'center',
        sortable: false,
        width: 200
    },
    {
        text: '申请编号',
        value: 'uid',
        align: 'center',
        sortable: false,
        width: 180
    },
    {
        text: '申请人',
        value: 'apply_user',
        align: 'center',
        sortable: false,  
        width: 120
    },
    {
        text: '状态',
        value: 'type',
        align: 'center',
        sortable: false,
        fixed: true,
        class:'fixed fixed-100',
        width: 150,
        right:100,
    },
    {
        text: '操作',
        align: 'center',
        value: 'actions',
        sortable: false,
        width: 100,
        fixed: true,
        class:'fixed fixed-0',
        right:0,
    }
]